import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a size guide drawer.
 * Opens when an element with on:click="#size-guide-drawer/open" is clicked.
 *
 * @extends {DialogComponent}
 */
class SizeGuideDrawerComponent extends DialogComponent {
  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('size-guide-drawer-component')) {
  customElements.define('size-guide-drawer-component', SizeGuideDrawerComponent);
}
